module.exports = __webpack_public_path__ + "static/media/icn-warn.c05d4f16.svg";